<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <example-title src="example-1.html" title="Different sizes and colors of social bars" />
    <h4 :class="subheading">Default</h4>
    <vc-social-bar :items="social" />
    <h4 :class="subheading">Small</h4>
    <vc-social-bar button-color="red" size="small" :items="social" />
    <h4 :class="subheading">Large</h4>
    <vc-social-bar button-color="orange" size="large" :items="social" />
    <example-title src="social.js" title="Configuring the :items property" />
    <p><code>&lt;vc-social-bar /&gt;</code> is configured via JavaScript. Click the "get code" button to the right to see a sample of a
      typical configuration object.</p>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'
import Social from '../../static/examples/components/social-bar/social'

export default {
  name: 'SocialBarPage',
  data () {
    return {
      title: null,
      description: null,
      social: Social,
      subheading: ['subheading', 'font-grey', 'font-l-600'],
      example: null
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/social-bar.vue